// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ProjectDocumentStatus = function (x) {
    return x;
};
var tsBridgeProjectDocumentSt = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ProjectDocumentStatus")("__brandProjectDocumentStatus"));
    }
};
var writeProjectDocumentStatus = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showProjectDocumentStatus = Data_Show.showString;
var readProjectDocumentStatus = Simple_JSON.readString;
var ordProjectDocumentStatus = Data_Ord.ordString;
var newtypeProjectDocumentStatus = {
    Coercible0: function () {
        return undefined;
    }
};
var makeProjectDocumentStatus = ProjectDocumentStatus;
var eqProjectDocumentStatus = Data_Eq.eqString;
export {
    ProjectDocumentStatus,
    makeProjectDocumentStatus,
    unwrap,
    newtypeProjectDocumentStatus,
    eqProjectDocumentStatus,
    ordProjectDocumentStatus,
    showProjectDocumentStatus,
    readProjectDocumentStatus,
    writeProjectDocumentStatus,
    tsBridgeProjectDocumentSt
};
//# sourceMappingURL=index.js.map
